import api from "./axiosInstance";

export const getTechnicalRiders = async (artistId) => {
  const response = await api.get(
    `api/v1/technical-items/?artist=${artistId}`
  );
  return response.data;
};

export const createTechnicalRider = async (payload) => {
  const response = await api.post(
    "api/v1/technical-items/",
    payload
  );
  return response.data;
};

export const updateTechnicalRider = async (id, payload) => {
  const response = await api.patch(
    `api/v1/technical-items/${id}/`,
    payload
  );
  return response.data;
};


export const deleteTechnicalRider = async (id) => {
  await api.delete(`api/v1/technical-items/${id}/`);
};